import { IDocumentsUploadApi } from '@modules/documents/children/upload/types/api';
import { apiInstance } from '@core/api/instance';

export const DocumentsUpload: IDocumentsUploadApi = {
  create: (type, attachment, values) => apiInstance().post('newTms/Document/create', { type, attachment, ...values }),
  getFormFields: (type) => apiInstance().post('newTms/Document/getDocumentMetrics', { type })
};
